const local = {
  url: "http://127.0.0.1:8000",
};

const dev = {
  url: "https://automations.dev.digiadolphin.com/api",
};

const test = {
  url: "https://automations.test.digiadolphin.com/api",
};

const prod = {
  url: "https://automations.digiadolphin.com/api",
};

const config =
  process.env.REACT_APP_ENV === "prod"
    ? prod
    : process.env.REACT_APP_ENV === "test"
    ? test
    : process.env.REACT_APP_ENV === "dev"
    ? dev
    : local;

const apiConfig = config;
export default apiConfig;
